
// Step 1: Base alert types
export enum ALERT_TYPES {
  WARNING = 1,
  ERROR = 2,
  NEUTRAL = 3,
  POSITIVE = 4,
  CHAT = 5,
  MEDIA_DEVICE = 6,
  MEDIA_UPLOADED = 7,
  MEDIA_TITLE_ERROR = 8,
  PRESENTER_CAP = 9,
  INFO,
  GENERAL_ERROR,
};
export interface Alert {
	type: ALERT_TYPES,
	message: string,
	description?: string,
	buttonText?: string,
	autoWidth?: boolean,
	spinner?: boolean,
}